import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './PrivacyPolicyPages.scss';

class PrivacyPolicyPages extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-cgu">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.TERMS_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.TERMS_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{i18n.TEXT1_1}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>

                <ul>
                    <li>{i18n.TEXT2_2}</li>
                    <li>{i18n.TEXT2_3}</li>
                    <li>{i18n.TEXT2_4}</li>
                    <li>{i18n.TEXT2_5}</li>
                </ul>

                {i18n.TEXT2_6}
                <ul>
                    <li>{i18n.TEXT2_7}</li>
                    <li>{i18n.TEXT2_8}</li>
                    <li>{i18n.TEXT2_9}</li>{' '}
                </ul>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>
                <ul>
                    <li>{i18n.TEXT3_2}</li>
                    <li>{i18n.TEXT3_3}</li>
                    <li>{i18n.TEXT3_4}</li>
                    <li>{i18n.TEXT3_5}</li>
                    <li>{i18n.TEXT3_6}</li>
                </ul>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <ul>
                    <li>{i18n.TEXT4_2}</li>
                    <li>{i18n.TEXT4_3}</li>
                </ul>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>
                <ul>
                    <li>{i18n.TEXT6_2}</li>
                    <li>{i18n.TEXT6_3}</li>
                    <li>{i18n.TEXT6_4}</li>
                    <li>{i18n.TEXT6_5}</li>
                </ul>
                <p>{i18n.TEXT6_6}</p>

                <h3>{i18n.TITLE7}</h3>
                <p>{i18n.TEXT7_1}</p>

                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>
            </main>
        );
    }
}

PrivacyPolicyPages.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.PRIVACY_POLICY
    };
}

export default withTemplate(connect(mapStateToProps)(PrivacyPolicyPages), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/privacypolicy/PrivacyPolicyPages.js